import { Subscribe } from "@/widgets/classic-form/form";
import { Submit } from "./Submit";

export interface SubmitSectionProps {
    label?: string;
}

export const SubmitSection = ({ label }: SubmitSectionProps) => (
    <Subscribe
        selector={({ isDirty, isSubmitting }) => ({ disabled: isSubmitting || !isDirty, isSubmitting })}
        children={({ disabled, isSubmitting }) => (
            <Submit label={label} disabled={disabled} isSubmitting={isSubmitting} />
        )}
    />
);
